import { useLocation, Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { useState, useEffect } from "react";

interface RequireAuthProps {
  requiredClaim?: string;
  children?: React.ReactNode;
}

const RequireAuth = ({requiredClaim, children}: RequireAuthProps) => {  
  const { isLoggedIn, hasClaim } = useAuth();
  const location = useLocation(); 
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    setIsAuthenticated(isLoggedIn);
  }, [isLoggedIn]); 

  if (!isAuthenticated)
    <Navigate to="/login" state={{ from: location }} replace />;

  if (requiredClaim && !hasClaim(requiredClaim))
    return <Navigate to="/Forbidden" replace />

  return <>{children}</>;
};

export default RequireAuth;
